module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/azure.ee4e4bf0.svg";